package one.devsbox.www.ui.users

import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import compose.assets.Svg
import compose.assets.svg.Plus
import kotlinx.coroutines.launch
import one.devsbox.shared.ads.SharedIO
import one.devsbox.www.io.Repository
import one.devsbox.www.ui.widgets.ScreenContentAction
import one.devsbox.www.tools.ArgsId
import one.devsbox.www.www_portal.generated.resources.*
import tk.mallumo.compose.navigation.navTo_UserDUI
import tk.mallumo.compose.navigation.navTo_UserEUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class ListingUsersVM : NavigationViewModel() {
    private lateinit var ctx: ListingUsersCtx

    var contentActions by mutableStateOf<List<ScreenContentAction>>(emptyList())
        private set

    var state by mutableStateOf<DataState<SharedIO.Users>>(DataState.Loading())
        private set

    var loadingMore by mutableStateOf(false)
        private set

    val search = TextFieldState()

    interface Action {
        fun loadMore()
        fun reload()
        fun openDetail(id: Long)
        fun addUser()
        fun back()
    }

    val action = object : Action {
        override fun loadMore() {
            val currentState = state
            if (currentState is DataState.Result && !loadingMore && currentState.nnvl.items.size < currentState.nnvl.count) {
                fetchUsers(page = currentState.nnvl.page + 1)
            }
        }

        override fun reload() {
            fetchUsers(0)
        }

        override fun openDetail(id: Long) {
            ctx.nav.navTo_UserDUI(ArgsId(id))
        }

        override fun addUser() {
            ctx.nav.navTo_UserEUI()
        }

        override fun back() {
            ctx.nav.up()
        }
    }

    fun setup(ctx: ListingUsersCtx) {
        this.ctx = ctx
        fetchUsers(0)
    }

    private fun fetchUsers(page: Int) {
        if (page == 0) state = DataState.Loading()
        else loadingMore = true

        scope.launch {
            runCatching {
                Repository.ads.user.users(page)
            }.onSuccess { response ->
                if (page == 0) {
                    state = DataState.Result(response)
                } else {
                    val current = (state as? DataState.Result)?.nnvl
                    if (current != null) {
                        state = DataState.Result(
                            current.copy(
                                page = response.page,
                                items = current.items + response.items
                            )
                        )
                    }
                }
                loadingMore = false
                setupActions((state as DataState.Result).nnvl)
            }.onFailure {
                if (page == 0) state = DataState.Error(it.message ?: "Unknown error")
                loadingMore = false
                contentActions = emptyList()
            }
        }
    }

    private fun setupActions(users: SharedIO.Users) {
        contentActions = buildList {
            if (ctx.me.permission.user.write) {
                add(
                    ScreenContentAction(
                        text = Res.string.ui_users_listing_btn_add_user,
                        color = ctx.colorPrimaryContainer,
                        icon = Svg.Plus
                    ) {
                        action.addUser()
                    }
                )
            }
        }
    }

    override fun onRelease() {}
}

